export var FetchType = /*#__PURE__*/ function(FetchType) {
    FetchType["Next"] = "next";
    FetchType["Previous"] = "prev";
    FetchType["All"] = "all";
    return FetchType;
}({});

//# sourceMappingURL=types.js.map